import { useEffect, useState } from "react";
import { SettingResponse } from "../services/coworkerApiCalls/Setting/SettingsTypes";
import { useOktaAuth } from "@okta/okta-react";
import { getSettingByName } from "../services/coworkerApiCalls/Setting/Setting";
import { settingResponseToSetting } from "../services/helpers/SettingMapper";

function useDataApiSettingByName(name: string){
    const [setting, setSetting] = useState<SettingResponse>();

    const { authState } = useOktaAuth();
    const token = authState!.idToken!.idToken

    useEffect(() => {
        const getAllSettings = async () => {

            const settingTemporary = await getSettingByName(token, name);
            const settingResult = settingResponseToSetting(settingTemporary);
            setSetting(settingResult);

        };
        void getAllSettings();

    }, [token, name]); // Or [] if effect doesn't need props or state
    
    return setting?.value;
}
export { useDataApiSettingByName }